module.exports = __webpack_public_path__ + "img/happybrain_product1.9b612e9e.png";